<template>
  <div class="home" :style="{ '--base-dark': $theme.basedark, '--base-fore': $theme.basefore, '--base-light': $theme.baselight, '--base-color': $theme.basecolor }">
    <div v-if="$store.preview" class="cyb-card cyb-preview-text">
      <fa :icon="['fas', 'exclamation-triangle']" />
      <span>{{ labels.AnteprimaText }}</span>
      <fa :icon="['fas', 'exclamation-triangle']" />
    </div>
    <div v-if="form.note" class="cyb-card cyb-note-cliente">
      <fa class="fa" :icon="['far', 'sticky-note']" /><span>{{ form.note }}</span>
    </div>
    <div class="offer-grid">
      <div v-for="(prop, index) of form.proposte" :key="index" class="cyb-card" tabindex="10" sliding>
        <div class="cyb-card-image">
          <div class="img-container-wrapper">
            <div v-if="prop.immagini.length === 0" class="cyb-card-camera-desc">
              <span class="title row">
                <span v-for="(camera, idx) of prop.camere" :key="idx" class="col">{{ camera["descBreve_" + _lingua] }}</span>
              </span>
              <span class="subtitle row">
                <span v-for="(camera, idx) of prop.camere" :key="idx" class="col">{{ camera["trattamentodesc_" + _lingua] }}</span>
              </span>
            </div>
            <div
              v-for="(immagine, idx) of prop.immagini"
              :key="idx"
              :style="{
                '--row-span': immagine.rowspan,
                '--col-span': immagine.colspan
              }"
              class="img-wrapper"
            >
              <div class="cyb-card-camera-desc">
                <span class="title">
                  {{ prop.camere[idx]["descBreve_" + _lingua] }}
                </span>
                <span class="subtitle tariffa">
                  {{ prop.camere[idx]["tariffadesc_" + _lingua] }}
                </span>
                <span class="subtitle">
                  {{ prop.camere[idx]["trattamentodesc_" + _lingua] }}
                </span>
              </div>
              <img :src="immagine.src" :alt="`Proposta ${immagine.src.split('/').at(-1)}`" />
              <div v-if="!!immagine.plus" class="plus-overlay">
                <fa :icon="['fas', 'plus']" /><span>{{ immagine.plus }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="cyb-card-header">{{ labels.PropostaTitolo }} {{ prop.codice }}</div>
        <div class="cyb-card-content">
          <div class="card-details">
            <div class="card-details-item">
              <div class="card-details-name">{{ labels.datepicker["check-in"].toLowerCase() }}</div>
              <div class="card-details-value">
                <div class="cyb-chip">
                  <fa class="fa card-details-icon" :icon="['far', 'calendar']" />
                  <span>{{ prop.arrivo }}</span>
                </div>
              </div>
            </div>
            <div class="card-details-item">
              <div class="card-details-name">{{ labels.datepicker["check-out"].toLowerCase() }}</div>
              <div class="card-details-value">
                <div class="cyb-chip">
                  <fa class="fa card-details-icon" :icon="['far', 'calendar']" />
                  <span>{{ prop.partenza }}</span>
                </div>
              </div>
            </div>
            <div class="card-details-item">
              <div class="card-details-name">{{ labels.Adulti2 }}</div>
              <div class="card-details-value">
                <div class="cyb-chip">
                  <fa class="fa card-details-icon" :icon="['fas', 'male']" />
                  <span>{{ prop.adulti }}</span>
                </div>
              </div>
            </div>
            <div class="card-details-item">
              <div class="card-details-name">{{ labels.Bambini2 }}</div>
              <div class="card-details-value">
                <div class="cyb-chip">
                  <fa class="fa card-details-icon" :icon="['fas', 'child']" />
                  <span>{{ prop.bambini }}</span>
                </div>
              </div>
            </div>
            <div class="card-details-item">
              <div class="card-details-name">{{ labels.Rooms }}</div>
              <div class="card-details-value">
                <div class="cyb-chip">
                  <fa class="fa card-details-icon" :icon="['fas', 'bed']" />
                  <span>{{ prop.camere.length }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cyb-card-footer">
          <div class="flex items-center flex-col">
            <div v-if="prop.sconto" class="prezzo-originale">
              <svg class="line-trough" viewBox="0 0 100 100" preserveAspectRatio="none">
                <path d="M20 10 L20 10 L90 90" fill="none" stroke="#db4e4e" stroke-width="6" stroke-linecap="round" />
              </svg>
              <fa class="fa euro" :icon="['fas', $theme.eurosign]" />
              {{ prop.prezzo }} <span class="sconto">-{{ prop.sconto }}%</span>
            </div>
            <div class="proposta-prezzo" style="font-size: 1.2em">
              <fa class="fa euro" :icon="['fas', $theme.eurosign]" />
              {{ prop.prezzo_scontato }}
            </div>
          </div>
          <button class="base" tabindex="15" @click="openModal(prop)">
            <span>{{ labels.PropostaDettagli }}</span>
            <fa :icon="['fas', 'chevron-right']" />
          </button>
        </div>
      </div>
    </div>
    <!-- -------------------------------------------- F O O T E R -------------------------------------------- -->
    <cyb-footer :labels="labels" />
    <!-- -------------------------------------------- M O D A L S -------------------------------------------- -->
    <cyb-modal :visible="modal" :modaldata="modaldata" @modalClose="modalClose">
      <div class="room-list">
        <div v-for="(camera, index) of modaldata.camere" :key="index" class="cyb-card" horizontal elevated style="--card-padding: 0.5rem; --card-shadow-width: 2px">
          <div v-if="camera.immagini.length > 0" class="cyb-card-image-gallery" style="padding: 0">
            <agile center-mode nav-buttons infinite>
              <img v-for="(img, idx) of camera.immagini" :key="idx" :src="img" alt="" />
              <template v-slot:prevButton><fa class="fa chevron-left" :icon="['fas', 'chevron-left']" /></template>
              <template v-slot:nextButton><fa class="fa chevron-right" :icon="['fas', 'chevron-right']" /></template>
            </agile>
          </div>
          <div class="flex flex-column" style="gap: 0.5rem">
            <div class="cyb-card-header flex flex-col" style="gap: 0.5rem">
              <span>
                {{ camera["descBreve_" + _lingua] }}
              </span>
              <span class="subtitle">
                {{ camera["trattamentodesc_" + _lingua] }}
              </span>
              <div class="flex items-center" style="gap: 0.5rem; font-size: 0.75em">
                <span class="flex items-center" style="gap: 0.25rem">
                  <span v-if="+camera.adulti < 6" class="flex items-center" style="gap: 0.25rem">
                    <fa v-for="i of +camera.adulti" :key="i" :icon="['fas', 'user-alt']" size="xs" />
                  </span>
                  <span v-else class="flex items-center" style="gap: 0.25rem">
                    <fa :icon="['fas', 'user-alt']" size="xs" />
                    <fa :icon="['fas', 'times']" size="xs" />
                    {{ +camera.adulti }}
                  </span>
                  <span>{{ +camera.adulti === 1 ? labels.Adulto : labels.Adulti2 }}</span>
                </span>
                <span v-if="+camera.bambini > 0" class="flex items-center" style="gap: 0.25rem">
                  <span v-if="+camera.bambini < 6" class="flex items-center" style="gap: 0.25rem">
                    <fa :icon="['fas', 'user-alt']" size="xs" />
                  </span>
                  <span v-else class="flex items-center" style="gap: 0.25rem">
                    <fa :icon="['fas', 'user-alt']" size="xs" />
                    <fa :icon="['fas', 'times']" size="xs" />
                    {{ +camera.bambini }}
                  </span>
                  <span>{{ +camera.bambini === 1 ? labels.Bambino : labels.Bambini2 }}</span>
                </span>
              </div>
            </div>
            <div class="cyb-card-content">
              <span>
                {{ camera["descLunga_" + _lingua] }}
              </span>
            </div>
            <div class="cyb-card-section">
              <span class="cyb-card-section-title">{{ labels.Serv }}</span>
              <div :class="['cyb-card-setion-body cyb-section-servizi', camera.immagini.length == 0 ? 'no-images' : '']">
                <div v-for="(servizio, idx) of camera.servizi" :key="idx" class="cyb-servizio-camera">
                  <fa v-if="servizio.icon" :icon="servizio.icon.split(' ')" style="width: 15px" />
                  <fa v-else :icon="['far', 'circle']" style="width: 10px" />
                  <span>{{ servizio["label_" + _lingua] }}</span>
                </div>
              </div>
            </div>
            <div v-if="camera.servizi_aggiunti.length" class="cyb-card-section">
              <span class="cyb-card-section-title">{{ labels.ServSup2 }}</span>
              <div :class="['cyb-card-setion-body cyb-section-servizi', camera.immagini.length == 0 ? 'no-images' : '']">
                <div v-for="(servizio, idx) of camera.servizi_aggiunti" :key="idx" class="cyb-servizio-camera">
                  <fa :icon="['far', 'circle']" style="width: 10px" />
                  <span>{{ servizio["descrizione_" + _lingua] }}</span>
                </div>
              </div>
            </div>
            <div v-if="camera.note" class="cyb-card-section">
              <span class="cyb-card-section-title">{{ labels.Note }}</span>
              <div class="cyb-card-setion-body">
                {{ camera.note }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="flex flex-col">
          <div v-if="modaldata.sconto" class="prezzo-originale">
            <svg class="line-trough" viewBox="0 0 100 100" preserveAspectRatio="none">
              <path d="M20 10 L20 10 L90 90" fill="none" stroke="#db4e4e" stroke-width="6" stroke-linecap="round" />
            </svg>
            <fa class="fa euro" :icon="['fas', $theme.eurosign]" />
            {{ modaldata.prezzo }} <span class="sconto">-{{ modaldata.sconto }}%</span>
          </div>
          <div class="proposta-prezzo" style="font-size: 1.2em">
            <fa class="fa euro" :icon="['fas', $theme.eurosign]" />
            {{ modaldata.prezzo_scontato }}
          </div>
        </div>
        <button class="base" style="flex: 1" right :disabled="$store.preview" @click="btnAvanti(riepilogoData(modaldata))">
          <span>{{ labels.btnAvanti }}</span>
          <fa :icon="['fas', 'arrow-right']" />
        </button>
      </div>
    </cyb-modal>
  </div>
</template>

<script>
import CybFooter from "../components/cybfooter.vue";
import CybModal from "../components/cybmodal.vue";
import apiService from "../services/api";
import formService from "../services/form";
import baseMixin from "../mixins/base";

export default {
  components: {
    CybFooter,
    CybModal
  },
  mixins: [baseMixin],
  data() {
    return {
      form: {
        proposte: []
      },
      labels: { privacy: {} },
      controller: "BE_proposte",
      modal: false,
      modaldata: {},
      multipro: [],
      debug: true
    };
  },
  computed: {
    _lingua() {
      return this.$store.lang.toLowerCase();
    }
  },
  mounted() {
    this.$store.lastpage = "proposte";

    this.$store.err = [];
    this.$store.db = this.$route.query.RPC_db;
    this.$store.idhotel = this.$route.query.idhotel;
    this.$store.lang = this.$route.query.lan;
    this.$store.preventivo = this.$route.query.preventivo;
    this.$store.preview = typeof this.$route.query?.preview !== "undefined";

    if (this.$store.form?.preventivo) {
      this._fill(this.form, this.$store.form);
    }
    formService.init(this);

    this._loadHotel().then((resp) => {
      let promise = Promise.resolve();
      if (!this.$route.query.preview) {
        promise = this.notificaLinkAperto();
      }
      promise.then(() => {
        const endpoint = this.controller + "/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.$store.preventivo;
        return apiService
          .get(endpoint)
          .then((resp) => {
            this.form.note = resp.note;
            this.form.proposte = resp.proposte.map((prop) => {
              const immaginiCamere = prop.camere.map((cam) => cam.immagini?.[0]).filter((img) => !!img);
              if (immaginiCamere.length > 0) {
                this.calcLayoutImmagini(immaginiCamere);
                immaginiCamere.length = Math.min(4, immaginiCamere.length);
              }
              return {
                ...prop,
                immagini: immaginiCamere,
                titolo: this.labels.PropostaTitolo + " " + prop.codice
              };
            });

            // apre modale se si torna indietro alla pagina
            const idproposta = this.form.proposte.find((prop) => prop.id === this.$store.proposta);
            if (idproposta) {
              this.openModal(idproposta);
            }
          })
          .catch((err) => {
            this.$store.err = err.msg;
            this._error();
          });
      });
    });
  },
  methods: {
    // :::::::::::::::::::::::::::::::: GESTIONE DATI ::::::::::::::::::::::::::::::::
    // cambia struttura
    switchHotel(idhotel) {
      window.location.href = window.location.href.replace(this.$store.idhotel, idhotel);
    },
    _loadHotel() {
      return apiService
        .get("BE_booking/" + this.$store.db + "/" + this.$store.idhotel)
        .then((resp) => {
          if (!resp.hotel) {
            this._error("ERR_HOTEL");
            return;
          }

          // dati principali hotel
          for (const item in resp.hotel) {
            if (Object.prototype.hasOwnProperty.call(resp.hotel, item)) {
              this.$hotel[item] = resp.hotel[item];
            }
          }
          this.nota_multi = resp.nota_multi;

          // colori e sfondo
          this.$theme.basecolor = resp.colore;
          this.$theme.basefore = formService.perceivedBrightness(this.$theme.basecolor) > 138 ? "#000000" : "#ffffff";
          this.$theme.eurosign = resp.eurosign;
          this.$theme.basedark = formService.brightness(this.$theme.basecolor, -50);
          this.$theme.baselight = formService.brightness(this.$theme.basecolor, 50);
          if (resp.sfondo) {
            this.$theme.background = resp.sfondo;
          }

          // bottoni multiproprietà
          this.multipro = resp.multipro;
        })
        .catch((err) => {
          for (let i = 0; i < err.msg?.length; i++) {
            this.$store.err.push(err.msg[i]);
          }
          if (this.$store.err.length > 0) {
            this._error();
          } else {
            this._error("ERR_HOTEL");
          }
        });
    },
    notificaLinkAperto() {
      return apiService.put(this.controller + "/link_aperto/" + this.$store.preventivo + "/" + this.$store.db, { idhotel: this.$store.idhotel }).catch((err) => {
        this.$store.msg = err.msg;
        this._error();
      });
    },
    /**
     * Calcola il layout della griglia immagini delle proposta (*max 4 immagini visibili*)
     * @param {string[]} immagini
     */
    calcLayoutImmagini(immagini) {
      const layout = { rowspan: null, colspan: null, plus: false };
      const surplus = immagini.length - 4;
      switch (immagini.length) {
        case 0:
          break;
        case 1:
          immagini[0] = { ...layout, src: immagini[0], rowspan: "span 2", colspan: "span 2" };
          break;
        case 2:
          immagini[0] = { ...layout, src: immagini[0], rowspan: "span 2", colspan: "auto" };
          immagini[1] = { ...layout, src: immagini[1], rowspan: "span 2", colspan: "auto" };
          break;
        case 3:
          immagini[0] = { ...layout, src: immagini[0], rowspan: "span 2", colspan: "auto" };
          immagini[1] = { ...layout, src: immagini[1], rowspan: "auto", colspan: "auto" };
          immagini[2] = { ...layout, src: immagini[2], rowspan: "auto", colspan: "auto" };
          break;
        case 4:
        default:
          immagini[0] = { ...layout, src: immagini[0], rowspan: "auto", colspan: "auto" };
          immagini[1] = { ...layout, src: immagini[1], rowspan: "auto", colspan: "auto" };
          immagini[2] = { ...layout, src: immagini[2], rowspan: "auto", colspan: "auto" };
          immagini[3] = { ...layout, src: immagini[3], rowspan: "auto", colspan: "auto", plus: surplus };
          break;
      }
    },
    openModal(data) {
      this.$store.proposta = data.id;
      this.$route.query.proposta = data.id;
      this.modaldata = {
        ...data,
        ospiti: data.camere.map((cam) => {
          return {
            ...cam,
            titolo: cam.descBreve,
            servizi: [
              ...cam.servizi_aggiunti.map((serv) => {
                return {
                  ...serv,
                  titolo: serv.descrizione
                };
              })
            ],
            tariffa: {
              key: cam.tariffaid + "-" + cam.trattamento,
              policy: cam.tariffapolicy,
              tipo: cam.tariffadesc,
              trattamento: cam.trattamentodesc,
              prezzo: cam.prezzo,
              prezzo_base: cam.prezzo,
              codice: cam.tariffa
            },
            key: cam.id
          };
        }),
        periodo: {
          dataarrivo: data.arrivo,
          datapartenza: data.partenza,
          notti: data.num_notti
        },
        preventivo: this.$route.query.preventivo,
        proposta: data.id,
        titolo: this.labels.PropostaTitolo + " " + data.codice
      };
      delete this.modaldata.immagini;
      this.modal = true;
    },
    modalClose() {
      this.modal = false;
      setTimeout(() => {
        this.modaldata = {};
      }, 300);
    },
    btnAvanti(data) {
      this._goNext("/form", data);
    },
    riepilogoData(data) {
      const result = {
        periodo: {
          dataarrivo: data.arrivo,
          datapartenza: data.partenza,
          notti: data.num_notti
        },
        ospiti: data.camere.map((cam) => {
          return {
            key: cam.id,
            tipo_camera: cam.tipo_camera,
            codice: cam.codice,
            titolo: cam.descBreve_ita,
            adulti: cam.adulti,
            bambini: cam.eta_bambini,
            tariffa: {
              key: cam.tariffaid,
              tipo: cam.tariffadesc_ita,
              trattamento: cam.trattamentodesc_ita,
              prezzo: cam.prezzo_scontato,
              prezzo_base: cam.prezzo_scontato,
              policy: cam.tariffapolicy
            },
            servizi: cam.servizi_aggiunti.map((serv) => ({
              codice: serv.codice,
              tipo: serv.tipo,
              prezzo: serv.prezzo_scontato,
              titolo: serv.descrizione_ita
            }))
          };
        })
      };
      return result;
    }
  }
};
</script>

<style lang="scss">
@import "src/css/variables.scss";

.home {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  button {
    all: unset;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: #ffffff;
    border: 1px solid #cecece;
    padding: 0.25rem 1rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
    &:hover {
      background-color: color-mix(in srgb, #ffffff, #000 10%);
    }
    &[right] {
      justify-content: flex-end;
    }
  }
  button.base {
    background-color: var(--base-color);
    color: var(--base-fore);
    border-color: transparent;
    &:hover,
    &:focus-visible {
      background-color: color-mix(in srgb, var(--base-color), #000 10%);
    }
    &:focus-visible {
      outline: 2px solid $text;
    }
    &[outline] {
      position: relative;
      background-color: transparent;
      color: inherit;
      border-color: var(--base-color);
      border-width: 2px;
      &:before {
        content: "";
        position: absolute;
        inset: 0;
        width: 0%;
        background-color: var(--base-color);
        mix-blend-mode: multiply;
        transition: width 3s cubic-bezier(0, 0, 0, 1);
      }
      &:hover:before {
        width: 100%;
      }
    }
    &:disabled {
      color: color-mix(in srgb, var(--base-fore), #000 20%);
      background-color: color-mix(in srgb, var(--base-color), #000 20%);
      cursor: not-allowed;
    }
  }
  .agile__nav-button {
    background: transparent;
    border: none;
    color: #ffffff;
    cursor: pointer;
    font-size: 16px;
    position: absolute;
    top: 0;
    bottom: 0;
    transition-duration: 0.3s;
    width: 20px;
    &:hover {
      background-color: rgba(#000, 0.4);
      opacity: 1;
    }
    &.agile__nav-button--prev {
      left: 0;
    }

    &.agile__nav-button--next {
      right: 0;
    }
  }
  .agile__dots {
    bottom: 0;
    left: 50%;
    position: absolute;
    translate: -50% 0;
    .agile__dot {
      margin: 0 8px;
      button {
        background-color: transparent;
        border: 1px solid #ffffff;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        width: 8px;
        height: 8px;
        font-size: 0;
        line-height: 0;
        margin: 0;
        padding: 0;
        transition-duration: 0.3s;
      }
      &.agile__dot--current,
      &:hover button {
        border-radius: 50%;
        background-color: #ffffff;
      }
    }
  }
  .offer-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
    gap: 0.5rem;
  }
  .proposta-prezzo {
    color: $prezzo;
  }
  .modal-data {
    .modal-footer {
      padding: 0;
      display: flex;
      align-items: center;
      gap: 1rem;
      border: none;
      margin-top: 1rem;
    }
  }
  .room-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .cyb-card {
    /* Card variables */
    --cc-card-background: #ffffff;
    --cc-card-background-dark: color-mix(in srgb, var(--cc-card-background), #000 10%);
    --cc-card-background-darker: color-mix(in srgb, var(--cc-card-background), #000 30%);
    --card-padding: 1rem;
    --card-shadow-width: 4px;

    /* Styles */
    position: relative;
    border: none;
    outline: none;
    background-color: var(--cc-card-background);
    display: flex;
    gap: 0.5rem;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--card-padding);
    &:focus-visible {
      outline: 2px solid $text;
    }
    &[rounded] {
      border-radius: 0.5rem;
    }
    &[horizontal] {
      flex-direction: row;
      justify-content: flex-start;
      & > *:first-child {
        padding-left: var(--card-padding);
      }
      & > *:last-child {
        padding-right: var(--card-padding);
      }
      & > * {
        padding: var(--card-padding) 0;
        height: 100%;
      }
    }
    &[elevated] {
      box-shadow: 0 0 calc(var(--card-shadow-width) * 2) var(--card-shadow-width) #0002;
      transition: box-shadow 0.2s ease;
      &:hover {
        box-shadow: 0 0 calc(var(--card-shadow-width) * 2) var(--card-shadow-width) #0006;
      }
    }
    &[bordered] {
      border: 2px solid var(--cc-card-background-dark);
      transition: border 0.2s ease;
      &:hover {
        border-color: var(--cc-card-background-darker);
      }
    }
    &[sliding] {
      transition: translate 0.2s ease;
      &:hover {
        translate: 0 -4px;
      }
    }
    &.cyb-preview-text {
      padding: 1rem;
      outline: 2px solid var(--base-color);
      outline-offset: -4px;
      flex-direction: row;
      align-items: center;
      // opacity: 0.8;
      span {
        flex: 1;
      }
    }
    &.cyb-note-cliente {
      flex-direction: row;
      align-items: flex-start;
      outline: 2px solid $text;
      .fa {
        margin-top: 5px;
      }
      span {
        flex: 1;
      }
    }
    .cyb-card-image {
      width: 100%;
      .img-container-wrapper {
        --grid-gap: 2px;
        position: relative;
        aspect-ratio: 2 / 1;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 150px);
        gap: 2px;
        &[rounded] {
          border-radius: 0.5rem;
          overflow: hidden;
        }
        &[bordered] {
          border-bottom: 2px solid var(--base-color);
        }
        .cyb-card-camera-desc {
          position: absolute;
          color: $text;
          width: 100%;
          padding: calc(var(--card-padding) / 2) calc(var(--card-padding) / 1.5);
          display: flex;
          flex-direction: column;
          background-image: linear-gradient(180deg, #0004, transparent);
          text-shadow: 0 0 2px black;
          .title {
            font-weight: bold;
            font-size: 1em;
          }
          .subtitle {
            font-size: 0.75em;
            font-weight: 400;
          }
          .tariffa {
            font-weight: 900;
          }
        }
        .img-wrapper {
          position: relative;
          grid-row: var(--row-span);
          grid-column: var(--col-span);
          width: 100%;
          height: 100%;
          .cyb-card-camera-desc {
            color: #ffffff;
            background-image: linear-gradient(180deg, #0006, transparent);
          }
          .plus-overlay {
            position: absolute;
            inset: 0;
            background-color: #0005;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0.25rem;
          }
          img {
            object-fit: cover;
            height: 100%;
            width: 100%;
          }
        }
      }
    }
    .cyb-card-image-gallery {
      max-width: 600px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .cyb-card-header {
      font-size: 1.4em;
      .subtitle {
        font-size: 0.7em;
        color: color-mix(in srgb, $text, #fff 35%);
      }
    }
    .cyb-card-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      .card-details {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        .card-details-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0.5rem;
          .card-details-name {
            display: flex;
            justify-content: flex-start;
            text-transform: capitalize;
          }
          .card-details-value {
            display: flex;
            justify-content: flex-end;
            gap: 0.5rem;
          }
        }
      }
    }
    .cyb-card-section {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 0.5rem;
      .cyb-card-section-title {
        font-size: 1.2em;
        font-weight: bold;
      }
      .cyb-card-setion-body {
        display: grid;
      }
      .cyb-section-servizi {
        grid-template-columns: repeat(2, 1fr);
        &.no-images {
          grid-template-columns: repeat(3, 1fr);
        }
        .cyb-servizio-camera {
          display: grid;
          grid-template-columns: 30px 1fr;
          align-items: center;
          & > :first-child {
            place-self: center;
          }
        }
      }
    }
    .cyb-card-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
  }
  .cyb-chip {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border: 1px solid #dedede;
    padding: 0.25rem 1rem;
  }
}

@keyframes float {
  from {
    translate: 0 0;
  }
  to {
    translate: 0 4px;
  }
}
</style>
